export const VISITOR_PAGE_SIZE = 20;

/** Admin directory — Office Records → Visitor (all records) */
export const VISITOR_ADMIN_TABLE_COLUMNS = [
  { id: "visitor_id", label: "Visitor ID" },
  { id: "entry_date", label: "Date" },
  { id: "visitor_name", label: "Visitor Name" },
  { id: "mobile_number", label: "Mobile" },
  { id: "purpose_name", label: "Purpose" },
  { id: "person_to_meet_name", label: "Person To Meet" },
  { id: "in_time", label: "In Time" },
  { id: "out_time", label: "Out Time" },
  { id: "created_by_name", label: "Registered By" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Action" },
];

/** Office / receptionist directory */
export const VISITOR_OFFICE_TABLE_COLUMNS = [
  { id: "visitor_id", label: "Visitor ID" },
  { id: "entry_date", label: "Date" },
  { id: "visitor_name", label: "Visitor Name" },
  { id: "mobile_number", label: "Mobile" },
  { id: "purpose_name", label: "Purpose" },
  { id: "person_to_meet_name", label: "Person To Meet" },
  { id: "in_time", label: "In Time" },
  { id: "out_time", label: "Out Time" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Action" },
];

/** @deprecated use role-specific column constants */
export const VISITOR_TABLE_COLUMNS = VISITOR_OFFICE_TABLE_COLUMNS;
